import React, { memo, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DefaultView from "../components/DefaultView";
import EmailLeftbar from "../components/EmailLeftbar";
import FaxAlertTableRow from "../components/FaxAlertTableRow";
import { actionGetAlerts } from "./../store/actions/settingAction";
import moment from "moment";
import EmptyResult from "../components/EmptyResult";

const FaxAlerts = memo(({ actionGetAlerts, user, alertLoader, alertData }) => {
  useEffect(() => {
    if (user) {
      actionGetAlerts();
    }
  }, [actionGetAlerts, user]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* start page title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 main_heading">Fax Alerts</h4>
              <div className="page-title-right">
                <DefaultView />
              </div>
            </div>
            {/* <div className="d-flex justify-content-end mb-3">
              <div className="btn-group float-end">
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-left" />
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div> */}
          </div>
        </div>
        {/* end page title */}
        <div className="row">
          <div className="col-12">
            {/* Left sidebar */}
            <EmailLeftbar />
            {/* End Left sidebar */}

            {/* Right Sidebar */}
            <div className="email-rightbar mb-3 compose-section">
              <div className="card">
                <div className="btn-toolbar p-3 d-flex justify-content-between align-items-start" role="toolbar">
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <div className="fs-6 text-dark mb-1">Set up and manage automated alerts for your fax communications and activities.</div>
                      <div className="text-muted small">Configure notifications to stay informed about incoming faxes, delivery confirmations, and system status updates.</div>
                    </div>
                  </div>
                  <div className="ms-3">
                    <Link
                      to="/fax-alerts/create"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="fa fa-plus me-2" />
                      Add
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-editable table-nowrap align-middle table-edits">
                      <thead>
                        <tr style={{ cursor: "pointer" }}>
                          <th>Alert Name</th>
                          <th>Alert For</th>
                          <th>Alert Type</th>
                          <th>Alert Created</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {alertLoader &&
                          [...Array(5)].map((_, i) => (
                            <tr key={i}>
                              <td><div className="skeleton" style={{ width: "80%" }} /></td>
                              <td><div className="skeleton" style={{ width: "60%" }} /></td>
                              <td><div className="skeleton" style={{ width: "70%" }} /></td>
                              <td><div className="skeleton" style={{ width: "50%" }} /></td>
                              <td><div className="skeleton" style={{ width: "40%" }} /></td>
                            </tr>
                          ))
                        }
                        {!alertLoader &&
                          alertData.length > 0 &&
                          alertData.map((data) => (
                            <FaxAlertTableRow
                              key={data.alert_ID}
                              id={data.alert_ID}
                              alert_value={data.alert_value}
                              alert_for={data.alert_for}
                              alert_type={data.alert_type}
                              user={user && user.user_ID}
                              alert_added={moment(data.alert_added).format(
                                "YYYY-MM-DD hh:mm A"
                              )}
                            />
                          ))}
                        {!alertLoader &&
                          alertData &&
                          alertData.length === 0 && (
                            <tr>
                              <td colSpan={5}>
                                <EmptyResult
                                  title="No Alerts Found"
                                  description="You currently have no alerts. Click 'Add' to create a new alert."
                                  iconSize={50}
                                />
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* card */}
            </div>
            {/* end  Right Sidebar Col-9 */}
          </div>
        </div>
      </div>
    </div>
  );
});

const mapStateToProps = (state) => {
  return {
    alertLoader: state.setting.alertLoader,
    alertData: state.setting.alertData,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, {
  actionGetAlerts,
})(FaxAlerts);
